import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { groupHomeActions } from 'srcReact/GroupHomePage'
import { groupActions } from '../../GroupPage/actions'
import { useTranslation } from 'react-i18next'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import useInfinitScroll from 'srcReact/helpers/hooks/useInfinitScroll'
import InviteWPMembers from 'srcReact/components/common2/InviteWPMembers'

function InviteWorkplaceMembersToGroup(props) {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  //states
  const [groupId, setGroupId] = useState()
  const [search, setSearch] = useState('')
  const [order, setOrder] = useState('name')

  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [showFinalizeModal, setShowFinalizeModal] = useState(false)
  const [pagination, setPagination] = useState({
    nextOffset: 0,
    isPagination: false
  })

  const {
    common: { isNative, isMobile },
    groupHome: {
      group,
      usersToInvite: { list, stats, loading }
    }
  } = useSelector((state) => state)

  //side effects
  useEffect(() => {
    const id = props.match.params.group_id
    setGroupId(id)
  }, [])

  useEffect(() => {
    dispatch(groupHomeActions.getUsersToInvite(groupId, search, order, pagination))
  }, [groupId, order, search, pagination])

  const lastUserRef = useInfinitScroll(loading, stats?.remaining, stats?.next_offset, setPagination, [loading])

  const handleOrderByChange = (order) => {
    setOrder(order.value)
    setPagination({ nextOffset: 0, isPagination: false })
  }

  const handleSearchMember = (searchValue) => {
    setSearch(searchValue)
    setPagination({ nextOffset: 0, isPagination: false })
  }

  const handleSendInvites = (id, membersId, message, callback) => {
    dispatch(groupActions.sendInvites(id, membersId, message, callback))
  }

  return (
    <PageContainer pageTitle={t('invite_group_mixr.pageTitle')} withFooter={false}>
      <InviteWPMembers
        id={groupId}
        name={group?.name}
        location={group?.location}
        type='group'
        coverPicture={group?.picture}
        order={order}
        search={search}
        users={list}
        loading={loading}
        lastUserRef={lastUserRef}
        isPagination={pagination.isPagination}
        handleSearchMember={handleSearchMember}
        handleOrderByChange={handleOrderByChange}
        handleSendInvites={handleSendInvites}
      />
    </PageContainer>
  )
}

export default InviteWorkplaceMembersToGroup
